import theme from '../../base';

const input = {
  background: theme.colors.neutrals.white,
  disabledBackground: theme.colors.neutrals.gray250,
  border: theme.colors.neutrals.gray500,
  error: theme.colors.reds.red500,
  focusBorder: theme.colors.blues.blue500,
  text: theme.colors.neutrals.gray700,
  placeholderText: theme.colors.neutrals.gray500,
  disabledPlaceholderText: theme.colors.neutrals.gray500,
  label: theme.colors.neutrals.gray800,
  message: theme.colors.neutrals.gray700,
  helperLink: theme.colors.blues.blue700,
  icon: theme.colors.neutrals.gray500,
};

export default input;
